export const findElements = (selector, parent) => Array.prototype.slice.call((parent || document).querySelectorAll(selector));
